import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";
import { fullGradientColors } from "@/components/AIComponents/AiComponents.style";
const { ui } = constants.colors;

export const outerWrapperCss: CSSObject = {
  marginTop: "2em",
  display: "inline-block",
  width: "100%",
  padding: "1px",
  borderRadius: "8px",
  background: `linear-gradient(102deg, ${fullGradientColors.position0.color} 0%, ${fullGradientColors.position25.color} 25%, ${fullGradientColors.position50.color} 50%, ${fullGradientColors.position100.color} 100%)`,
};

export const innerWrapperCss: CSSObject = {
  borderRadius: "8px",
  background: ui.white[100],
  width: "100%",
  height: "100%",
};

export const collapseButtonCss: CSSObject = {
  width: "100%",
};

export const borderWrapperCss: CSSObject = {
  "::before": {
    content: "''",
    height: "100%",
    border: `4px solid ${ui.white[25]}`,
    background: "white",
    position: "absolute",
    left: "28px",
    marginTop: "-2em",
  },
};
